export default __webpack_public_path__ + "static/media/Girdle of Untamed Violence.bd6bf952.jpg";